var viewer_caption_rtlignore_default = {
  "fontElementMap": "zCHCg",
  "imageCaption": "pw15V"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
